import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import $ from 'jquery'
import { semanticColors } from '../Globals/styles';

class NewSuggestSelectInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideSuggestions: true,
      class: Math.round(Math.random() * 20000000000).toString()
    };
  }
  onBlur = () => {
    this.setState({ hideSuggestions: true });
    if (this.props.onBlur) this.props.onBlur();
  };
  onInputChange = (evt) => {
    var selected = { id: null, name: evt.target.value };
    this.setState({ hideSuggestions: false });
    this.props.onQuery(selected.name)
    this.props.onChange(selected);
  };
  componentDidMount = () => {
    this.refs.input.value = this.props.value.name
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.value.name !== this.props.value.name)
      $("." + this.state.class).val(nextProps.value.name);
  };
  onItemSelected = (suggestion) => {
    this.setState({ hideSuggestions: true });
    this.props.onChange(suggestion);
  };
  shouldCompRenderSuggestions = () => {
    return (this.props.suggestions.length < 1 ||
      this.state.hideSuggestions)
  };
  renderSuggestions = () => {
    if (this.shouldCompRenderSuggestions()) return null;
    var that = this;
    var sugNodes = this.props.suggestions.map(s => {
      return that.renderSuggestionItem(s);
    });
    return <div style={styles.container}>
      <ul
        style={[styles.listGroup, this.props.listgroupStyle]}
        className="list-group"
        ref="ul">
        {sugNodes}
      </ul>
    </div>
  };
  renderSuggestionItem = (suggestion) => {
    return <li
      style={styles.listGroupItem}
      onMouseDown={() => {
        this.onItemSelected(suggestion)
      }}
      onClick={() => {
        this.onItemSelected(suggestion)
      }}
      onTouchEnd={() => {
        this.onItemSelected(suggestion)
      }}
      key={suggestion.id}>
      {suggestion.name}
    </li>
  };

  render() {
    return (
      <div style={styles.outerContainer}>
        <input
          onClick={this.props.onClick}
          disabled={this.props.isDisabled}
          ref="input"
          className={this.state.class}
          onBlur={this.onBlur}
          onChange={this.onInputChange}
          placeholder={this.props.placeholder}
          style={[styles.input, this.props.inputStyle && this.props.inputStyle]}
        />
        {this.renderSuggestions()}
        {this.props.children}
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    position: 'relative'
  },
  container: {
    width: '100%',
    paddingRight: '24px',
    position: 'absolute',
    zIndex: '2000'
  },
  listGroup: {
    borderRadius: '2px',
    width: '100%',
    boxShadow: '0 3px 8px #ddd',
    backgroundColor: '#fff'
  },
  listGroupItem: {
    cursor: 'pointer',
    padding: '5px 30px 5px 15px',
    border: 'none',
    display: 'block',
    clear: 'both',
    fontWeight: 'normal',
    lineHeight: '1.4em',
    color: '#333333',
    wordWrap: 'break-word',
    textAlign: 'left',
    ':hover': {
      backgroundColor: semanticColors.infoLighter
    }
  },
  input: {
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    borderRadius: '2px'
  }
}
NewSuggestSelectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onQuery: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
};
export default Radium(NewSuggestSelectInput);


// WEBPACK FOOTER //
// ./src/App/Common/newSuggestSelectInput.jsx